import React, { Component } from 'react';
import SelectPassengers from './SelectPassengers';
import { getText } from '../config';

class PassengersMenu extends Component {
    static defaultProps = {
        childAges: []
    }

    render() {
        return (
            <div className={"passengers-menu" + (this.props.childAges.length > 0 ? " shrink" : "")}>
                <SelectPassengers
                    icon={this.props.imgPath + "adult"}
                    text={getText('adult')}
                    value={this.props.adult}
                    addClick={this.props.plusClick.bind(null, 'adult')}
                    lessClick={this.props.minusClick.bind(null, 'adult')}
                />
                <SelectPassengers
                    icon={this.props.imgPath + "child"}
                    childAges={this.props.childAges}
                    addClickAge={this.props.plusClickAge}
                    lessClickAge={this.props.minusClickAge}
                    isMobile={this.props.isMobile}
                    roomId={this.props.roomId}
                    selectAges={this.props.selectAges}
                    text={getText('child')}
                    subText={getText('childSubText')}
                    searchType={this.props.searchType}
                    value={this.props.child}
                    addClick={this.props.plusClick.bind(null, 'child')}
                    lessClick={this.props.minusClick.bind(null, 'child')}
                />
                <SelectPassengers
                    icon={this.props.imgPath + "baby"}
                    text={getText('baby')}
                    subText={getText('babySubText')}
                    value={this.props.baby}
                    addClick={this.props.plusClick.bind(null, 'baby')}
                    lessClick={this.props.minusClick.bind(null, 'baby')}
                />
                <SelectPassengers
                    icon={this.props.imgPath + "senior"}
                    text={getText('senior')}
                    subText={getText('seniorSubText')}
                    value={this.props.senior}
                    addClick={this.props.plusClick.bind(null, 'senior')}
                    lessClick={this.props.minusClick.bind(null, 'senior')}
                    last={true}
                />

            </div>
        );
    }
}

PassengersMenu.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default PassengersMenu;


// WEBPACK FOOTER //
// ./src/components/PassengersMenu.js